import { Link } from "react-router-dom"

function Breadcrumb({ text, subText = '', route = '', routeID = '' }) {
    return (
        <section className="breadcum">
            <div className="container">
                <div className="breadcum-content">
                    <h2 className="title">{text}</h2>
                    <h4 className="para"><Link to='/'>Bosh sahifa</Link> / {route != '' ? <><Link to={route}>{text}</Link> / {subText}</> : text}</h4>
                </div>
            </div>
        </section>
    )
}

export default Breadcrumb